module.exports = __webpack_public_path__ + "media/sync.eb762921.mp4";